import domain_list from "../../Data/domain_list";

// license_basic, license_sini_ai, license_sini_data, quota
export const is_pass_license_or_quota = () => (dispatch, getState) => {
  const {
    license_sharing,
    license_basic,
    license_sini_ai,
    license_sini_data,
    license_user_status,
    license_group_status,
  } = getState()?.license_reducer;
  const {
    isAuthenticated,
    modal_payment_universal,
    quota_access_sini_ai = 0,
    quota_access,
  } = getState()?.auth;

  // const payment_type = license_basic?.payment_type;

  const logic_1 =
    !(
      license_basic?.is_has_license &&
      license_sini_ai?.is_has_license &&
      license_sini_data?.is_has_license
    ) && !license_user_status?.is_has_license;

  const logic_2 =
    !license_sharing?.is_has_license && !license_group_status?.is_has_license;
  const logic_3 = quota_access <= 0;
  const logic_4 = quota_access_sini_ai <= 0;

  if (!isAuthenticated) {
    //suruh login
    const { modal_login } = this.props.auth;
    dispatch({
      type: "set_value_user",
      payload: {
        key: "modal_login",
        value: !modal_login,
      },
    });
  }

  // kalo nggak punya lisensi maupun quota akses
  else if (logic_1 && logic_2 && logic_3 && logic_4) {
    // suruh beli lisensi
    dispatch({
      type: "set_value_user",
      payload: {
        key: "modal_payment_universal",
        value: !modal_payment_universal,
      },
    });
    return false;
  } else {
    return true;
  }
};

export const is_pass_license_sharing = () => (dispatch, getState) => {
  const {
    license_basic,
    license_sharing,
    license_user_status,
    license_group_status,
  } = getState()?.license_reducer;
  const { isAuthenticated } = getState()?.auth;

  // const payment_type = license_basic?.payment_type;
  const logic_1 = !["team", "enterprise"].includes(license_basic?.payment_type);

  const logic_1_old = !["license_2", "license_3"].includes(
    license_user_status?.payment_type
  );

  const logic_2 = !license_sharing?.is_has_license;
  const logic_2_old = !license_group_status?.is_has_license;

  if (!isAuthenticated) {
    //suruh login
    const { modal_login } = this.props.auth;
    dispatch({
      type: "set_value_user",
      payload: {
        key: "modal_login",
        value: !modal_login,
      },
    });
  } else if (logic_1 && logic_1_old && logic_2 && logic_2_old) {
    return false;
  } else {
    return true;
  }
};

export const is_has_license_basic_or_license_sharing =
  () => (dispatch, getState) => {
    const {
      license_basic,
      license_sharing,
      license_user_status,
      license_group_status,
    } = getState()?.license_reducer || {};

    if (
      license_basic?.is_has_license ||
      license_sharing?.is_has_license ||
      license_user_status?.is_has_license ||
      license_group_status?.is_has_license
    ) {
      return true;
    } else {
      return false;
    }
  };

export const is_has_license_basic_and_license_sharing =
  () => (dispatch, getState) => {
    const {
      license_basic,
      license_sharing,
      license_user_status,
      license_group_status,
    } = getState()?.license_reducer;

    if (
      (license_basic?.is_has_license || license_sharing?.is_has_license) &&
      (license_user_status?.is_has_license ||
        license_group_status?.is_has_license)
    ) {
      return true;
    } else {
      return false;
    }
  };

export const get_payment_id_from_license = () => (dispatch, getState) => {
  const {
    license_basic,
    license_sharing,
    license_user_status,
    license_group_status,
  } = getState()?.license_reducer;
  if (license_basic?._id) {
    return license_basic?._id;
  } else if (license_user_status?._id) {
    return license_user_status?._id;
  } else if (license_sharing?._id) {
    return license_sharing?._id;
  } else if (license_group_status?._id) {
    return license_group_status?._id;
  } else {
    return null;
  }
};

// const is_user_get_access_by_feature_key = (feature_key) =>{}

// const is_user_get_access_by_license_key = (license_key) =>{}

export const is_user_get_access_by_license_key =
  (license_key) => (dispatch, getState) => {
    const payment_type_keys = [
      "license_1",
      "license_2",
      "license_3",
      "team",
      "enterprise",
    ];
    const payment_type_can_share_license_keys = [
      "license_2",
      "license_3",
      "team",
      "enterprise",
    ];
    const new_license_keys = [
      "license_basic",
      "license_sini_ai",
      "license_sini_data",
    ];
    const { quota_access_sini_ai = 0, quota_access } = getState()?.auth;
    const license_reducer = getState()?.license_reducer || {};

    const { license_sharing, license_group_status, license_user_status } =
      getState()?.license_reducer || {};

    let result = false;
    let needed_licenses = {};
    if (
      (payment_type_keys.includes(license_user_status?.payment_type) &&
        license_user_status?.is_has_license) ||
      quota_access > 0 ||
      quota_access_sini_ai > 0
    ) {
      result = true;
    } else if (
      (payment_type_can_share_license_keys.includes(license_sharing?.payment_type) &&
        license_sharing?.is_has_license) ||
      (payment_type_can_share_license_keys.includes(license_group_status?.payment_type) &&
        license_group_status?.is_has_license)
    ) {
      result = true;
    } else if (new_license_keys.includes(license_key)) {
      const index_license = new_license_keys.findIndex(
        (item) => item === license_key
      );

      let is_pass_licenses = true;
      for (let idx = index_license; idx >= 0; idx--) {
        const license = license_reducer?.[new_license_keys[idx]];
        if (!license?.is_has_license) {
          is_pass_licenses = false;
          needed_licenses[new_license_keys[idx]] = true;
        } else {
          needed_licenses[new_license_keys[idx]] = false;
        }
      }
      result = is_pass_licenses;
    }

    // kalo nggak punya lisensi maupun quota akses
    if (!result) {
      // suruh beli lisensi
      // dispatch({
      //   type: "set_value_user",
      //   payload: {
      //     key: "modal_payment_universal",
      //     value: !modal_payment_universal,
      //   },
      // })
      // return false

      return {
        ...needed_licenses,
        is_pass: false,
      };
    } else {
      // return true
      return {
        is_pass: true,
        need_basic: false,
        need_sini_ai: false,
        need_sini_data: false,
      };
    }
  };

export const is_user_have_master_collaboration_access =
  () => (dispatch, getState) => {
    const sharing_license_keys = [
      "license_2",
      "license_3",
      "team",
      "enterprise",
    ];
    const { license_basic, license_user_status } =
      getState()?.license_reducer || {};

    let result = false;
    if (
      (sharing_license_keys.includes(license_user_status?.payment_type) &&
        license_user_status?.is_has_license) ||
      (sharing_license_keys.includes(license_basic?.payment_type) &&
        license_basic?.is_has_license)
    ) {
      result = true;
    }

    return result;
  };

export const is_have_license_enterprise_as_member_or_owner = () => (dispatch, getState) => {
  const { license_basic, license_user_status, license_group_status, license_sharing } =
    getState()?.license_reducer || {};
  if (
    license_group_status?.payment_type === "license_3" ||
    license_sharing?.payment_type === "enterprise" ||
    license_basic?.payment_type === "enterprise" ||
    license_user_status?.payment_type === "license_3"
  ) {
    return true;
  }
  return false;
}

export const is_user_have_access_as_master_collaboration_or_have_license_sharing =
  () => (dispatch, getState) => {
    const sharing_license_keys = [
      "license_2",
      "license_3",
      "team",
      "enterprise",
    ];
    const { license_basic, license_user_status, license_group_status, license_sharing } =
      getState()?.license_reducer || {};

    let result = false;
    if (
      (sharing_license_keys.includes(license_user_status?.payment_type) &&
        license_user_status?.is_has_license) ||
      (sharing_license_keys.includes(license_basic?.payment_type) &&
        license_basic?.is_has_license) ||
      (sharing_license_keys.includes(license_group_status?.payment_type) &&
        license_group_status?.is_has_license) ||
      (sharing_license_keys.includes(license_sharing?.payment_type) &&
        license_sharing?.is_has_license)
    ) {
      result = true;
    }

    return result;
  };


export const block_license_with_handler = (block_type) => (dispatch, getState) => {

  const domain_w_port = window.location.host;
  const is_domain_kai = domain_list[domain_w_port]?.is_domain_kai;

  const {
    modal_payment_universal,
    modal_block_license_universal,
    modal_ketengan_universal,
  } = getState()?.auth;

  // detail lapor untuk client kai
  if (is_domain_kai || block_type === "kai") {
    dispatch({
      type: "set_value_user",
      payload: {
        key: "modal_block_license_universal",
        value: !modal_block_license_universal,
      },
    });
  }
  // pricing ketengan
  else if (block_type === "ketengan") {
    dispatch({
      type: "set_value_user",
      payload: {
        key: "modal_ketengan_universal",
        value: !modal_ketengan_universal,
      },
    });
  }
  // pricing
  else {
    dispatch({
      type: "set_value_user",
      payload: {
        key: "modal_payment_universal",
        value: !modal_payment_universal,
      },
    });
  }
}